import {
	Bike,
	Crosshair,
	Dumbbell,
	Footprints,
	Layers,
	Pencil,
	Target,
	Timer,
	Waves,
	Zap,
} from "lucide-react";

/**
 * Lucide icon resolvers extracted from ProgramBuilder.js. Kept in a shared
 * module (rather than programBuilderUtils.js) because they return Lucide icon
 * components. Behavior is identical to the original inline helpers.
 */
export const exerciseTypeIcon = (type) => {
	const icons = {
		strength: Dumbbell,
		running: Footprints,
		swim: Waves,
		bike: Bike,
		erg: Timer,
		conditioning: Zap,
		// Dry fire: si lavora sul mirino senza sparare. Live fire: il bersaglio.
		dry_fire: Crosshair,
		live_fire: Target,
	};
	return icons[type] || Dumbbell;
};

export const ergTypeIcon = (ergType) => {
	if (ergType === "rowerg") return Waves;
	if (ergType === "bikeerg") return Bike;
	if (ergType === "skierg") return Timer;
	if (ergType === "assault_bike") return Zap;
	if (ergType === "mixed_erg") return Layers;
	if (String(ergType).startsWith("rowerg")) return Waves;
	if (String(ergType).startsWith("bikeerg")) return Bike;
	if (String(ergType).startsWith("skierg")) return Timer;
	if (String(ergType).startsWith("assault_bike")) return Zap;
	if (String(ergType).startsWith("mixed_erg")) return Layers;
	if (ergType === "custom") return Pencil;
	return Timer;
};
